"use client";
import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import Link from "next/link";
import { NavItemProps } from "./navitem.types";

import classes from "./navitem.module.css";
import clsx from "clsx";

const NavItem: React.FC<NavItemProps> = ({
  page,
  selectedPage,
  setSelectedPage,
  icon,
  text,
  count,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const isSelected = selectedPage === page;

  useEffect(() => {
    if (pathname === "/" + page) {
      setSelectedPage(page);
    }
  }, [pathname, page, setSelectedPage]);

  const handleClick = () => {
    setSelectedPage(page);
    router.push("/" + page);
  };

  return (
    <Link
      href={`/${page}`}
      onClick={handleClick}
      prefetch={true}
      className={clsx(classes.navItem, { [classes.selected]: isSelected })}
    >
      <span className={classes.icon}>{icon}</span>
      <span className={classes.text}>{text}</span>
      {count && <span className={classes.count}>{count}</span>}
    </Link>
  );
};

export { NavItem };
